'use client';
import { ChevronDown, ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { useOptions } from '@/lib/api/common/options.queries';
import { useActiveProfessions } from '@/features/jobs/api/jobs.queries';
import { trackStatistic } from '@/lib/utils/statisticTracker';
import SidebarSection from './SidebarSection';
import { generateLink, getOptionLabel, getUniqueId } from './sidebar.utils';
import { useSidebarFilter } from './useSidebarFilter';

const BranchComponent = () => {
  const { searchParams, isChecked, handleCheckboxChange } = useSidebarFilter();
  const { data: branches } = useOptions({ gkey: 'branch' });
  const branchId = Number(searchParams.get('branchId')) || 0;
  const { data: professions } = useActiveProfessions(branchId);

  return (
    <SidebarSection title="Салбар мэргэжил">
      <ul className="flex flex-col gap-4">
        {(branches ?? []).map((option, optionIndex) => {
          const isSelected = branchId === option.id;
          return (
            <li key={optionIndex} className="cursor-pointer">
              <Link
                href={generateLink('branchId', String(option.id), searchParams)}
                passHref
                className="flex gap-2 group"
                onClick={() => trackStatistic('sidebar_filter')}
              >
                {isSelected ? (
                  <ChevronDown size="14" className="text-primary shrink-0" />
                ) : (
                  <ChevronRight size="14" className="text-primary shrink-0" />
                )}
                <span className="leading-5">{getOptionLabel(option)}</span>
              </Link>
              {isSelected && (
                <ul className="flex flex-col gap-2 ml-4 pt-4">
                  {(professions ?? []).map((child, childIndex) => (
                    <li
                      key={childIndex}
                      className="flex gap-2 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        className="shrink-0"
                        id={getUniqueId('professionIds', String(child.id))}
                        checked={isChecked('professionIds', String(child.id))}
                        onChange={(e) =>
                          handleCheckboxChange(
                            'professionIds',
                            String(child.id),
                            e.target.checked
                          )
                        }
                      />
                      <label
                        htmlFor={getUniqueId('professionIds', String(child.id))}
                        className="leading-5 cursor-pointer select-none"
                      >
                        {getOptionLabel(child)}
                      </label>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </SidebarSection>
  );
};

export default BranchComponent;
